<template>
	<div>
		<div class="tabs-div dis-fle ali-cen">
			<div class="left flex-1 dis-fle ali-cen">
				<span :class="{ avtive: avtive == index }" v-for="(value, index) in periodList" :key="index"
					@click="avtive = index">{{ value.value }}</span>
			</div>
			<div class="right dis-fle ali-cen">
				<!-- <span class="avtive">基础图</span>
				<span class="">深度图</span> -->
			</div>
		</div>
		<kLine ref="kLine" @close="getClose" :period="timeValue" :symbol="code" :price="productInfo.price"
			:high="productInfo.price_high" :low="productInfo.price_low" :chartHeight="665"></kLine>
	</div>
</template>
<script>
import kLine from './kLine.vue';
export default {
	components: { kLine },
	props: {
		productInfo: {
			type: Object,
			default: () => { }
		},
		code: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			avtive: 0,
		};
	},
	computed: {
		periodList() {
			return this.productInfo.periodList || []
		},
		timeValue() {
			return this.periodList[this.avtive]?.value || ''
		},
	},
	methods: {
		// k线
		getClose(e) {
			console.log(e)
		},
	},
};
</script>
<style lang="scss" scoped>
.tabs-div {
	display: flex;
	padding: 32px 16px;
	color: #999;
	cursor: pointer;

	.left {
		span {
			margin-right: 48px;
		}
	}

	.right {
		span {
			margin-left: 40px;
		}
	}

	.avtive {
		color: #00f0ff;
	}
}
</style>